module.exports = __webpack_public_path__ + "img/KG.b835c7fc.svg";